// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loadingSpinner_cSti6"};